import React, { useState, useEffect } from "react";
import { NumericFormat } from "react-number-format";
import { isCoverValueEmpty } from "../../store/helperfuncs";

const AddEditCovers = ({
  coverid,
  setValue,
  isEditBinder,
  setUpdating,
  responseDetail,
  responseid,
}) => {
  const [coverinput, setCoverInput] = useState(
    isCoverValueEmpty(coverid.covervalue) ? null : coverid.covervalue
  );
  const handleChange = (event) => {
    let inputvalue = Number(event.value);
    if (
      event.value === "" ||
      inputvalue === "" ||
      inputvalue === null ||
      inputvalue === undefined
    ) {
      setCoverInput(null);
    } else if (!isNaN(inputvalue)) setCoverInput(inputvalue);
  };
  const handleBlur = (event) => {
    setUpdating(true);
    setTimeout(() => {
      setValue({
        value: coverinput,
        id: coverid.id,
      });
      setUpdating(false);
    }, 500);
  };

  useEffect(() => {
    if (coverid.inputvaluetype == "currency" && coverid.covervalue) {
      setCoverInput(parseFloat(coverid.covervalue).toFixed(2));
    } else setCoverInput(coverid.covervalue);
  }, [coverid?.covervalue]);

  const disabledFun = () => {
    if (coverid?.id == 3) {
      return true;
    }
    if (responseid != undefined) {
      if (responseDetail?.source == "manual") {
        return false;
      } else return true;
    } else {
      return isEditBinder;
    }
  };

  return (
    <>
      {coverid.inputvaluetype === "currency" ? (
        <NumericFormat
          className="form-control"
          type="text"
          placeholder="$ "
          prefix={"$ "}
          thousandSeparator={true}
          fixedDecimalScale
          coverinputmode="numeric"
          id={"coverinput - " + coverid.id}
          value={parseFloat(coverinput).toFixed(2)}
          onValueChange={handleChange}
          onBlur={handleBlur}
          disabled={disabledFun()}
        ></NumericFormat>
      ) : null}
      {["percent", "percent2f"].includes(coverid.inputvaluetype) ? (
        <NumericFormat
          className="form-control"
          type="text"
          placeholder={"%"}
          suffix={"%"}
          decimalScale={coverinput >= 100 ? 0 : 2}
          coverinputmode="numeric"
          id={"coverinput - " + coverid.id}
          value={coverinput < 1 ? coverinput * 100 : coverinput}
          onValueChange={(values) => {
            values?.floatValue > 100 || values?.floatValue < 0
              ? handleChange({
                  floatValue: 100,
                  formattedValue: "100,00",
                  value: "100",
                })
              : handleChange(values);
          }}
          min={1}
          max={100}
          maxLength={coverinput >= 100 || coverinput <= 0 ? 3 : null}
          onBlur={handleBlur}
          onKeyPress={(event) => {
            var regxp =
              coverid.inputvaluetype == "percent2f" ? /[0-9.]/ : /[0-9]/;
            if (!regxp.test(event.key)) {
              event.preventDefault();
            }
          }}
          disabled={disabledFun()}
        ></NumericFormat>
      ) : null}
    </>
  );
};

export default AddEditCovers;
